<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblEditTemplate</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>
      </div>
      <form [formGroup]="editTemplateForm" (ngSubmit)="SaveTemplateDetails()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div *ngIf="templateInfo" class="form-group">
                <div class="row">
                  <div class='col'>
                    <div class="row">
                      <div class="col" translate>
                        <label class="text" for="dealerId" translate>lblSelectDealer <strong
                            class="required">*</strong></label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <select class="form-control" [(ngModel)]="templateInfo.dealerId" formControlName="dealerId"
                          id="dealerId">
                          <option disabled translate [ngValue]="'-1'">lblAllDealer</option>
                          <option *ngFor="let dealer of dealerList" [ngValue]="dealer.value">
                            {{dealer.text}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class='col'>
                    <div class="row">
                      <div class="col" translate>
                        <label class="text" for="templateType" translate>lblChannel <strong
                            class="required">*</strong></label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <select class="form-control" [(ngModel)]="templateInfo.templateType"
                          formControlName="templateType" id="templateType">
                          <option disabled [value]="0" translate>lblSelectChannelName</option>
                          <option *ngFor="let templateItem of templateTypeList" [value]="templateItem.value">
                            {{templateItem.text}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class='col'>
                    <div class="row">
                      <div class="col" translate>
                        <label class="text" for="applicationId" translate>lblSection <strong
                            class="required">*</strong></label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <select class="form-control" [(ngModel)]="templateInfo.applicationId"
                          formControlName="applicationId" id="applicationId">
                          <option disabled translate>lblSelectSection</option>
                          <option *ngFor="let module of moduleList" [selected]="templateInfo.applicationId==module.id"
                            [ngValue]="module.id">{{module.name}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class='col-3'>
                    <div class="row">
                      <div class="col" translate>
                        <label class="text" for="templateUsageId" translate>lblTemplateUsage <strong
                            class="required">*</strong></label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <select class="form-control" [(ngModel)]="templateInfo.templateUsageId"
                          formControlName="templateUsageId" id="templateUsageId">
                          <option disabled translate>lblSelectTemplateUsage</option>
                          <option *ngFor="let templateUsage of templateUsageList"
                            [selected]="templateInfo.templateUsageId==templateUsage.id" [ngValue]="templateUsage.id">
                            {{templateUsage.name}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-4"></div>
                <div class=" row">
                  <div class='col-3'>
                    <div class="row">
                      <div class="col" translate>
                        <label class="text" for="cc" translate>Cc</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <input type="text" class="form-control" [(ngModel)]="templateInfo.cc" formControlName="cc"
                          id="cc">
                      </div>
                    </div>
                  </div>
                  <div class='col-3'>
                    <div class="row">
                      <div class="col" translate>
                        <label class="text" for="bcc" translate>Bcc</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <input type="text" class="form-control" [(ngModel)]="templateInfo.bcc" formControlName="bcc"
                          id="bcc">
                      </div>
                    </div>
                  </div>
                  <div class='col-3'>
                    <div class="row">
                      <div class="col" translate>
                        <label class="text" for="actionType" translate>lblEvent <strong
                            class="required">*</strong></label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <select class="form-control" [(ngModel)]="templateInfo.actionTypeCode"
                          formControlName="actionTypeCode" id="actionType">
                          <option disabled translate>lblSelectEvent</option>
                          <option *ngFor="let actionType of actionTypeList"
                            [selected]="templateInfo.actionTypeCode==actionType.actionCode"
                            [ngValue]="actionType.actionCode" translate>
                            {{actionType.actionLabelKey}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class='col-3'>
                    <div class="row">
                      <div class="col" translate>
                        <label class="text" for="userType" translate>lblUserType <strong
                            class="required">*</strong></label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <select class="form-control" [(ngModel)]="templateInfo.userTypeId" formControlName="userTypeId"
                          id="userTypeId">
                          <option disabled [ngValue]="0" translate>lblSelectUserType</option>
                          <option *ngFor="let user of userTypeList" [selected]="templateInfo.userTypeId==user.id"
                            [ngValue]="user.id">
                            {{user.name}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class='col-3'>
                    <div class="row">
                      <div class="col" translate>
                        <label class="text" for="templateScope" translate>lblTemplateScope </label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <ng-select [multiple]="false" class="w-100" placeholder="{{ 'lblSelectTemplateScope' | translate }}"
                          [(ngModel)]="templateInfo.templateScope" formControlName="templateScope" name="templateScope">
                          <ng-option *ngFor="let item of templateScopeList" [value]="item.id">
                            {{item.name}}
                          </ng-option>
                        </ng-select>
                      </div>
                    </div>
                 </div>
                  <div class='col-3 mt-4'>
                    <div class="row">
                      <div class="col af-form-group">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input" id="isActive"
                            [checked]="templateInfo.isActive" formControlName="isActive"
                            [(ngModel)]="templateInfo.isActive">
                          <label class="custom-control-label" for="isActive" translate>lblActive</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-4"></div>
                <div class="row">
                  <div class="col-md-9">
                    <div class="form-group">
                      <div *ngIf="t">
                        <div class="row" *ngFor="let ticket of t.controls; let i = index">
                          <div [formGroup]="ticket" class="col-12">
                            <input type="hidden" formControlName="languageId" class="form-control mb-2"
                              [(ngModel)]="templateInfo.templateDescriptions[i].languageId" maxlength="30">
                            <div class="mt-5"></div>
                            <div class="border pad15 relative">
                              <div class="header-sub">{{languageList[i].value}}</div>
                              <div class="row mt-3">
                                <div class='col'>
                                  <div class="row">
                                    <div class="col" translate>
                                      <label class="text" for="name" translate>lblName <strong
                                          class="required">*</strong></label>
                                    </div>
                                  </div>
                                  <div class=" row">
                                    <div class="col">
                                      <input formControlName="name" class="form-control mb-2"
                                        [(ngModel)]="templateInfo.templateDescriptions[i].name" maxlength="100"
                                        required>
                                    </div>
                                  </div>
                                </div>
                                <div class='col'>
                                  <ng-container
                                    *ngIf="templateInfo.templateType != channelType.Sms; else loadElseSubject">
                                    <div class="row">
                                      <div class="col" translate>
                                        <label class="text" for="subject" translate>lblSubject <strong
                                            class="required">*</strong></label>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col">
                                        <input formControlName="subject" class="form-control mb-2"
                                          [(ngModel)]="templateInfo.templateDescriptions[i].subject" maxlength="100"
                                          required>
                                      </div>
                                    </div>
                                  </ng-container>
                                  <ng-template #loadElseSubject>
                                    <input type="hidden" formControlName="subject" class="form-control mb-2"
                                      [(ngModel)]="templateInfo.templateDescriptions[i].subject" maxlength="100">
                                  </ng-template>
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class='col'>
                                  <div class="row">
                                    <div class="col" translate>
                                      <label class="text" for="body" translate>lblBody</label>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col">
                                       <ng-container *ngIf="templateInfo.templateType != channelType.Sms && templateInfo.templateType != channelType.PushNotification; else loadElseBody">                                        
                                          <quill-editor format="html" formControlName="body" 
                                          [(ngModel)]="templateInfo.templateDescriptions[i].body"
                                          (onEditorCreated)="onEditorCreated($event, i)" 
                                          [modules]="options" required></quill-editor>
                                      </ng-container>
                                      <ng-template #loadElseBody>
                                        <textarea class="form-control" formControlName="body" rows="6"
                                          [(ngModel)]="templateInfo.templateDescriptions[i].body" required></textarea>
                                      </ng-template>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mt-5">
                      <div class="col" translate>
                        <label class="text" for="fieldDetails" translate>lblFieldDetails</label>
                        <em class="fas fa-info-circle fa-lg ml-2" ngbTooltip="{{'lblHelp' | translate}}" (click)="OpenTemplateFieldHelp()"></em>
                      </div>
                    </div>
                    <div id="templateFields" class="template-fields">
                      <ul class="mt-3">
                        <li *ngFor="let item of templateFieldList">
                          {{ '{' + item + '}' }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <a (click)="OnClose(false, true)" type="reset" class="btn btn-primary btn-lg" translate><em
                class="far fa-copy font16 align-top mr-2"></em>lblDuplicate</a>
              <button type="submit" aria-label="Center Align" class="btn btn-primary btn-lg ml-3" [disabled]="disabled()"
                translate><em class="far fa-save font16 align-top mr-2"></em>lblSaveChanges</button>
              <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg ml-3" translate><em
                  class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>